import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { convert } from "html-to-text";

/**
 * Converts HTML content to a clean text format and exports it to a .docx file
 */
export function exportToDocx(htmlContent: string) {
    // Convert HTML to plain text (removes CSS and extra tags)
    const plainText = convert(htmlContent, {
        wordwrap: 130,
        selectors: [{ selector: "h1", format: "uppercase" }],
    });

    // Create paragraphs for each line
    const paragraphs = plainText.split("\n").map((line) => new Paragraph(line));

    // Create the Word document
    const doc = new Document({
        sections: [{ children: paragraphs }],
    });

    // Convert to Blob and trigger download
    Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "MatFacilitatorResults.docx");
    });
}


